import { BadgeColor } from '@billy/design-system'

import { InvoiceStatus } from '../enums/invoiceStatus'

export const invoiceStatusToBadgeColor: Record<InvoiceStatus, BadgeColor> = {
  [InvoiceStatus.All]: 'neutral',
  [InvoiceStatus.Credited]: 'success',
  [InvoiceStatus.Draft]: 'accent',
  [InvoiceStatus.Overdue]: 'danger',
  [InvoiceStatus.Paid]: 'success',
  [InvoiceStatus.PartiallyCredited]: 'warning',
  [InvoiceStatus.PartiallyPaid]: 'warning',
  [InvoiceStatus.Unpaid]: 'warning',
}
